/** Standard embed message event names for host ↔ MFE drawer communication. */
export const DRAWER_HEADER_EVENT = 'set-drawer-header';
export const DRAWER_CLOSE_EVENT = 'close';
export const DRAWER_SUBMIT_EVENT = 'submit';
